<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title>Daily Light: Morning &amp; Evening</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="crt1" id="p0004-01-0">© 2013 Thomas Nelson, Inc.</p>
<p class="crt" id="p0004-01-1">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.</p>
<p class="crt" id="p0004-01-2">Published in Nashville, Tennessee by Thomas Nelson. Thomas Nelson is a registered trademark of Thomas Nelson, Inc.</p>
<p class="crt" id="p0004-01-3">Thomas Nelson, Inc. titles may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail Special Markets@ThomasNelson.com</p>
<p class="crt" id="p0004-P-1">Unless otherwise noted, Scripture quotations are taken from the New King James Version. © 1982 by Thomas Nelson, Inc. Used by permission. All rights reserved.</p>
<p class="crt" id="p0004-01-4">First published in the King James Version in Great Britain in 1794 by Samuel Bagster, a forerunner of Marshall Pickering.</p>
<p class="isbn" id="p0004-01-5">ISBN-13: 978-1-4003-2257-2</p>
<p class="printhistory" id="p0004-P-2"><i>Printed in China</i></p>
<p class="other" id="p0004-P-3">13 14 15 16 17 WAI 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?c23ae114